import { getAllowedGroupIds, hasGroupPermission, hasPermission, hasUserPermission } from '../helpers'

const PermissionMixin = {
	methods: {
		can(humanFriendlyPermission) {
			return (hasPermission(
				humanFriendlyPermission, 
				JSON.parse($('meta[name="logged-user-permissions"]').attr("content"))
			) || hasPermission(
				humanFriendlyPermission, 
				JSON.parse($('meta[name="logged-group-permissions"]').attr("content"))
			))
		},
		canCreateGroupGatherings(id) {
			if (hasUserPermission('createGatherings')) {
				return true
			}
			if (hasUserPermission('gatheringRestriction') && hasGroupPermission('createGatherings')) {
				return getAllowedGroupIds().includes(parseInt(id))
			}
			return false
		},
		canDeleteGroupGatherings(id) {
			if (hasUserPermission('deleteGatherings')) {
				return true
			}
			if (hasUserPermission('gatheringRestriction') && hasGroupPermission('deleteGatherings')) {
				return getAllowedGroupIds().includes(parseInt(id))
			}
			return false
		},
		canUpdateGroup(id) {
			if (hasUserPermission('updateGroups')) {
				return true
			}
			if (hasUserPermission('groupRestriction') && hasGroupPermission('updateGroups')) {
				return getAllowedGroupIds().includes(id)
			}
			return false
		},
		canUpdateGroupGatherings(id) {
			if (hasUserPermission('updateGatherings')) {
				return true
			}
			if (hasUserPermission('gatheringRestriction') && hasGroupPermission('updateGatherings')) {
				return getAllowedGroupIds().includes(parseInt(id))
			}
			return false
		},
		canViewGroupGatherings(id) {
			if (hasUserPermission('viewGatherings')) {
				return true
			}
			if (hasUserPermission('gatheringRestriction') && hasGroupPermission('viewGatherings')) {
				return getAllowedGroupIds().includes(id)
			}
			return false
		},
	}
}

export default PermissionMixin
